/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmployeesEmployeesEmployeeModel } from './employees-employees-employee-model';

export interface SuccessionManagementTalentRecommendationsTalentRecommendationApprovalModel {
  id: string;
  talentRecommendationId: string;
  acknowledgedById?: string | null;
  acknowledgedAt?: string | null;
  reason?: string | null;
  isRequired: boolean;
  stepName: string | null;
  state: SuccessionManagementTalentRecommendationsTalentRecommendationApprovalModelStateEnum;
  acknowledgedBy?: EmployeesEmployeesEmployeeModel;
  createdById: string;
  createdAt: string;
  updatedById: string;
  updatedAt: string;
}
export enum SuccessionManagementTalentRecommendationsTalentRecommendationApprovalModelStateEnum {
  Open = 'Open',
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
